import { buildLexer } from 'typescript-parsec';

/**
 * The token kinds that the lexer will produce.
 */
export enum TokenKind {
    // keywords
    KeywordIf,
    KeywordThen,
    KeywordElse,
    KeywordAnd,
    KeywordOr,
    KeywordNot,

    //symbols
    SymbolOpenParen,
    SymbolCloseParen,
    SymbolAsterisk,
    SymbolForwardSlash,
    SymbolPlus,
    SymbolMinus,
    SymbolLessThanEqual,
    SymbolGreaterThanEqual,
    SymbolLessThan,
    SymbolGreaterThan,

    // literals
    LiteralNumber,

    // Identifiers
    IdentifierCost,
    IdentifierClicks,
    IdentifierInstalls,
    IdentifierCPX,

    // statuses
    StatusActive,
    StatusPaused,
    StatusSkip,

    // whitespace
    Space,
}

export const lexer = buildLexer<TokenKind>([
    // keywords
    [true, /^if\s/g, TokenKind.KeywordIf],
    [true, /^then\s/g, TokenKind.KeywordThen],
    [true, /^else\s/g, TokenKind.KeywordElse],
    [true, /^and\s/g, TokenKind.KeywordAnd],
    [true, /^or\s/g, TokenKind.KeywordOr],
    [true, /^not\s/g, TokenKind.KeywordNot],

    // symbols
    [true, /^\(/g, TokenKind.SymbolOpenParen],
    [true, /^\)/g, TokenKind.SymbolCloseParen],
    [true, /^\*/g, TokenKind.SymbolAsterisk],
    [true, /^\//g, TokenKind.SymbolForwardSlash],
    [true, /^\+/g, TokenKind.SymbolPlus],
    [true, /^-/g, TokenKind.SymbolMinus],
    [true, /^<=/g, TokenKind.SymbolLessThanEqual],
    [true, /^>=/g, TokenKind.SymbolGreaterThanEqual],
    [true, /^</g, TokenKind.SymbolLessThan],
    [true, /^>/g, TokenKind.SymbolGreaterThan],

    // literals
    [true, /^\d+(\.\d+)?/g, TokenKind.LiteralNumber],

    // identifiers
    [true, /^cost\b/g, TokenKind.IdentifierCost],
    [true, /^clicks\b/g, TokenKind.IdentifierClicks],
    [true, /^installs\b/g, TokenKind.IdentifierInstalls],
    [true, /^cpx\b/g, TokenKind.IdentifierCPX],

    // statuses
    [true, /^active\b/g, TokenKind.StatusActive],
    [true, /^paused\b/g, TokenKind.StatusPaused],
    [true, /^skip\b/g, TokenKind.StatusSkip],

    // whitespace
    [false, /^\s+/g, TokenKind.Space],
]);
